const SocialIconMail = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.1848 3.62181L8 7.55657L14.8152 3.62181C14.4295 2.67168 13.4823 2 12.375 2H3.625C2.51765 2 1.57045 2.67168 1.1848 3.62181ZM15 5.59358L8.53932 9.32365C8.37087 9.42091 8.18867 9.4684 8.01243 9.47031C7.82857 9.47279 7.63714 9.42553 7.4608 9.32372L1 5.59358V11.4286C1 12.8487 2.17525 14 3.625 14H12.375C13.8247 14 15 12.8487 15 11.4286V5.59358Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconMail };
